import { CustomFieldViewModel, CustomFieldDataType } from '../models/configuration';
import { FieldMetadata, DataType } from '../models/expression';

const mapCustomFieldDataType = (customFieldDataType: CustomFieldDataType | string): DataType => {
  switch (customFieldDataType) {
    case CustomFieldDataType.String:
      return DataType.Text;
    case CustomFieldDataType.Integer:
    case CustomFieldDataType.Number:
      return DataType.Number;
    case CustomFieldDataType.Date:
    case CustomFieldDataType.DateTime:
      return DataType.Date;
    case CustomFieldDataType.Boolean:
      return DataType.TrueFalse;
    default:
      return DataType.Text;
  }
};

export const convertCustomFieldToFieldMetadata = (customField: CustomFieldViewModel): FieldMetadata => {
  return {
    fieldName: customField.name,
    dataType: mapCustomFieldDataType(customField.dataType),
    isList: false,
    enumType: null,
  };
};

export const convertCustomFieldsToFieldMetadata = (customFields: CustomFieldViewModel[]): FieldMetadata[] => {
  return customFields.map(convertCustomFieldToFieldMetadata);
};

export const mergeCustomFieldsWithMetadata = (
  fieldMetadata: FieldMetadata[],
  customFields: CustomFieldViewModel[]
): FieldMetadata[] => {
  const customFieldMetadata = convertCustomFieldsToFieldMetadata(customFields);
  return [...fieldMetadata, ...customFieldMetadata];
};

